<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">

        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-12">
                                    <h4 class="font-weight-bold text-primary">Add Product/Unit</h4>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-5">
                            <form @submit.prevent="addProduct" autocomplete="off">
                                <vue-good-wizard
                                        :steps="steps"
                                        :onNext="nextClicked"
                                        :onBack="backClicked">
                                    <div slot="page1">
                                        <h4>Select the Retailer/Wholesaler</h4>
                                        <div class="row mt-5">
                                            <div class="col-md-8 offset-2">
                                                <div class="form-group">
                                                    <label><b>Select Wholesaler/Retailer</b><span class="required">*</span></label>
                                                    <v-select v-model="form.shop" label="shop_name" :options="shops"
                                                              :reduce="shop => shop.user_id"
                                                              placeholder="Select Wholesaler/Retailer"></v-select>
                                                    <small style="color: red" v-if="error && errors.shop">{{
                                                        errors.shop[0] }}</small>
                                                    <small style="color: red" v-if="errn && errnv.shop">{{
                                                        errnv.shop}}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="page2">
                                        <h4>Add Product details</h4>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label><b>Select Category</b><span class="required">*</span></label>
                                                    <v-select v-model="form.category" label="name" :options="categories"
                                                              :reduce="category => category.id"
                                                              placeholder="Select Category"
                                                              @input="getSubCategories"></v-select>
                                                    <small style="color: red" v-if="error && errors.category">{{
                                                        errors.category[0]}}</small>
                                                    <small style="color: red" v-if="errn && errnv.category">{{
                                                        errnv.category}}</small>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label><b>Select Sub-Category</b><span class="required">*</span></label>
                                                    <v-select v-model="form.subcategory" label="name"
                                                              :options="subcategories"
                                                              :reduce="sub => sub.id" placeholder="Select Sub-Category"
                                                              @input="getBrands"></v-select>
                                                    <small style="color: red" v-if="error && errors.subcategory">{{
                                                        errors.subcategory[0] }}</small>
                                                    <small style="color: red" v-if="errn && errnv.subcategory">{{
                                                        errnv.subcategory}}</small>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label><b>Select Brand</b><span class="required">*</span></label>
                                                    <v-select v-model="form.brand" label="name" :options="brands"
                                                              :reduce="brand => brand.id"
                                                              placeholder="Select Brand"></v-select>
                                                    <small style="color: red" v-if="error && errors.brand">{{
                                                        errors.brand[0] }}</small>
                                                    <small style="color: red" v-if="errn && errnv.brand">{{
                                                        errnv.brand}}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label><b>Title</b><span class="required">*</span></label>
                                                    <input v-model="form.title" type="text" name="title"
                                                           placeholder="Title" class="form-control">
                                                    <small style="color: red" v-if="error && errors.title">{{
                                                        errors.title[0] }}</small>
                                                    <small style="color: red" v-if="errn && errnv.title">{{
                                                        errnv.title}}</small>

                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label><b>Price</b><span class="required">*</span></label>
                                                    <input v-model="form.price" type="number" name="price"
                                                           placeholder="price" class="form-control">
                                                    <small style="color: red" v-if="error && errors.price">{{
                                                        errors.price[0] }}</small>
                                                    <small style="color: red" v-if="errn && errnv.price">{{
                                                        errnv.price}}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label><b>Quantity/Size (Optional)</b></label>
                                                    <input v-model="form.quantity" type="text" name="quantity"
                                                           placeholder="Quantity/Size"
                                                           class="form-control">
                                                    <small style="color: red" v-if="error && errors.quantity">{{
                                                        errors.quantity[0] }}</small>
                                                    <small style="color: red" v-if="errn && errnv.quantity">{{
                                                        errnv.quantity}}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Description<span class="required">*</span></label>
                                                    <vue-editor v-model="form.description"
                                                                :editorToolbar="myToolbar"></vue-editor>
                                                    <small style="color: red" v-if="error && errors.description">{{
                                                        errors.description[0] }}</small>
                                                    <small style="color: red" v-if="errn && errnv.description">{{
                                                        errnv.description}}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="page3">
                                        <h4>Upload Images</h4>
                                        <div class="form-group">
                                            <label>Upload Images<span class="required">*</span></label>
                            <VueFileAgent
                                    :accept="'image/*'"
                                    :multiple="true"
                                    :deletable="true"
                                    :maxSize="'10MB'"
                                    :maxFiles="14"
                                    v-model="attachments"
                                    @select="filesSelected($event)"
                                    @delete="fileDeleted($event)"></VueFileAgent>
                            <small style="color: red" v-if="error && errors.files">{{ errors.files[0] }}</small>
                            <small style="color: red" v-if="errn && errnv.files">{{ errnv.files}}</small>
                        </div>
                        <hr>
                                    </div>
                                </vue-good-wizard>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>
<script>
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    import {VueEditor} from "vue2-editor";

    export default {
        name: 'addProducts',
        components: {
            VueEditor,
            Loading
        },
        data() {
            return {
                steps: [
                    {
                        label: 'Select the Retailer/Wholesaler',
                        slot: 'page1',
                    },
                    {
                        label: 'Add Item details',
                        slot: 'page2',
                    },
                    {
                        label: 'Upload Images',
                        slot: 'page3',
                    },
                ],
                filesDataForUpload: [],
                attachments: [],
                myToolbar: [["bold", "italic"], [{list: "ordered"}, {list: "bullet"}]],
                errors: {},
                error: false,
                errn: false,
                errnv: {},
                isLoading: false,
                fullPage: true,
                brands: [],
                categories: [],
                shops: [],
                subcategories: [],
                form: {
                    shop: '',
                    brand: '',
                    category: '',
                    subcategory: '',
                    title: '',
                    price: '',
                    description: '',
                    quantity: ''
                }
            }
        },
        methods: {
            nextClicked(currentPage) {
                if (currentPage == 0) {
                    if (!this.form.shop) {
                        this.errn = true;
                        this.errnv.shop = 'This field is required!';
                        return false;
                    } else {

                        this.errn = false;
                        this.errnv.shop = '';
                        return true;
                    }
                } else if (currentPage == 1) {
                    if (!this.form.category) {
                        this.errn = true;
                        this.errnv.category = 'This field is required!';
                        return false;
                    } else if (!this.form.subcategory) {
                        this.errn = true;
                        this.errnv.subcategory = 'This field is required!';
                        return false;
                    } else if (!this.form.brand) {
                        this.errn = true;
                        this.errnv.brand = 'This field is required!';
                        return false;
                    } else if (!this.form.title) {
                        this.errn = true;
                        this.errnv.title = 'This field is required!';
                        return false;
                    } else if (!this.form.price) {
                        this.errn = true;
                        this.errnv.price = 'This field is required!';
                        return false;
                    } else if (!this.form.description) {
                        this.errn = true;
                        this.errnv.description = 'This field is required!';
                        return false;
                    } else {
                        this.errn = false;
                        this.errnv.category = '';
                        this.errnv.subcategory = '';
                        this.errnv.brand = '';
                        this.errnv.title = '';
                        this.errnv.price = '';
                        this.errnv.quantity = '';
                        this.errnv.description = '';
                        return true;
                    }
                } else if (currentPage == 2) {
                    if (!this.filesDataForUpload.length) {
                        this.errn = true;
                        this.errnv.files = 'This field is required!';
                        return false;
                    }
                    this.errn = false;
                    this.errnv.files = '';
                    this.addProduct();
                    return true;

                }

            },
            backClicked() {
                return true; //return false if you want to prevent moving to previous
            },
            addProduct() {
                this.isLoading = true;
                let fd = new FormData();
                for (let i = 0; i < this.filesDataForUpload.length; i++) {
                    fd.append('files[]', this.filesDataForUpload[i].file);
                }
                fd.append('shop', this.form.shop);
                fd.append('brand', this.form.brand);
                fd.append('category', this.form.category);
                fd.append('subcategory', this.form.subcategory);
                fd.append('title', this.form.title);
                fd.append('price', this.form.price);
                fd.append('description', this.form.description);
                fd.append('quantity', this.form.quantity);

                const config = {headers: {'Content-Type': 'multipart/form-data'}};
                this.axios.post('/admin/shopLocal/products', fd, config).then(() => {
                    this.isLoading = false;
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Success!!',
                        text: 'Product added Successfully',
                    });
                    this.form = {
                        shop: '',
                        brand: '',
                        category: '',
                        subcategory: '',
                        title: '',
                        price: '',
                        description: '',
                        quantity: ''
                    }
                    this.filesDataForUpload = [];
                    this.attachments = [];
                })
                    .catch(error => {
                        this.isLoading = false;
                        this.error = true;
                        this.errors = error.response.data.errors;
                    });
            },
            fileDeleted: function (fileData) {
                var i = this.filesDataForUpload.indexOf(fileData);
                if (i !== -1) {
                    this.filesDataForUpload.splice(i, 1);
                } else {
                    this.deleteUploadedFile(fileData);
                }
            },
            filesSelected: function (filesDataNewlySelected) {
                var validFilesData = filesDataNewlySelected.filter((fileData) => !fileData.error);
                this.filesDataForUpload = this.filesDataForUpload.concat(validFilesData);
            },
            getSubCategories() {
                this.form.subcategory = '';
                this.form.brand = '';
                this.axios.get("/admin/shopLocal/sub-category/" + this.form.category).then(({data}) => ([this.subcategories = data]));
            },
            getCategories() {
                this.axios.get("/admin/shopLocal/category").then(({data}) => ([this.categories = data]));
            },
            getBrands() {
                this.form.brand = '';
                this.axios.get("/admin/shopLocal/my-brands/" + this.form.subcategory).then(({data}) => ([this.brands = data]));
            },
            getWholesaler() {
                this.axios.get("/admin/shopLocal/shop").then(({data}) => ([this.shops = data]));
            },
        },
        created() {
            this.getCategories();
            this.getWholesaler();
        }

    };
</script>
<style>
    .visually-hidden {
        position: absolute;
        width: 1px;
        height: 1px;
        left: -10000px;
        overflow: hidden;
    }

    .control, fieldset {
        margin: 6px 0;
    }


    .required {
        color: red;
    }
</style>
